import { SOCIAL_LINKS } from "../lib/funding";
import { Youtube, Instagram, Facebook, Link as LinkIcon, ExternalLink, Play } from "lucide-react";

export default function Vlog() {
  return (
    <div data-testid="vlog-page" className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-32 pb-24">
      <div className="mb-16 reveal">
        <p className="eyebrow mb-4">The Vlog</p>
        <h1 className="font-display text-6xl md:text-7xl mb-6 leading-[0.95]">
          Short notes from the <em style={{ color: "var(--brass)" }}>desk</em>.
        </h1>
        <p className="text-lg max-w-3xl leading-relaxed" style={{ color: "var(--ink-muted)" }}>
          Where our long-form interviews are slow and considered, the Vlog is brisk — daily field notes,
          quick wealth-building lessons, behind-the-scenes from the editorial desk, and dispatches from
          the road. Follow us across channels below.
        </p>
      </div>

      <hr className="hairline mb-12" />

      {/* YouTube Channel Feature */}
      <section className="mb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <a
              href={SOCIAL_LINKS.youtube}
              target="_blank"
              rel="noreferrer"
              data-testid="vlog-youtube-feature"
              className="block media-card relative aspect-video group"
              style={{ background: "var(--surface)", border: "1px solid var(--hairline)" }}
            >
              <div className="absolute inset-0 flex items-center justify-center" style={{ background: "linear-gradient(135deg, rgba(194,163,115,0.08), rgba(74,24,30,0.15))" }}>
                <div className="text-center">
                  <Youtube size={72} style={{ color: "var(--brass)" }} className="mx-auto mb-4" />
                  <p className="font-display text-4xl mb-2">@wealthfirstincTV</p>
                  <p className="text-xs uppercase tracking-[0.2em]" style={{ color: "var(--ink-muted)" }}>YouTube Channel</p>
                </div>
              </div>
              <div className="absolute bottom-6 right-6 px-4 py-2 flex items-center gap-2" style={{ background: "var(--bg)", border: "1px solid var(--brass)" }}>
                <Play size={14} fill="currentColor" style={{ color: "var(--brass)" }} />
                <span className="text-xs uppercase tracking-[0.2em]" style={{ color: "var(--brass)" }}>Watch on YouTube</span>
              </div>
            </a>
          </div>
          <div className="lg:col-span-5 lg:pl-6">
            <p className="eyebrow mb-3">Featured Channel</p>
            <h2 className="font-display text-4xl mb-5">WEALTH FIRST INC. TV</h2>
            <p className="text-base leading-relaxed mb-6" style={{ color: "var(--ink-muted)" }}>
              New short-form videos every week — strategy notes, interview previews, and behind-the-scenes
              from production. Subscribe on YouTube to never miss a release.
            </p>
            <a href={SOCIAL_LINKS.youtube} target="_blank" rel="noreferrer" className="btn-brass" data-testid="vlog-subscribe-youtube">
              Subscribe on YouTube
            </a>
          </div>
        </div>
      </section>

      <hr className="hairline mb-12" />

      {/* Social Grid */}
      <section className="mb-20">
        <div className="mb-10">
          <p className="eyebrow mb-3">More Channels</p>
          <h2 className="font-display text-4xl">Follow the daily dispatch.</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <SocialCard
            href={SOCIAL_LINKS.instagram}
            icon={Instagram}
            platform="Instagram"
            handle="@profitwealthfirst"
            description="Daily visual notes on wealth, leverage, and luxury."
            testId="social-instagram"
          />
          <SocialCard
            href={SOCIAL_LINKS.facebook}
            icon={Facebook}
            platform="Facebook"
            handle="wealthfirstinctv"
            description="Community discussions and interview drops."
            testId="social-facebook"
          />
          <SocialCard
            href={SOCIAL_LINKS.linktree}
            icon={LinkIcon}
            platform="Linktree"
            handle="linktr.ee/wealthfirstinc"
            description="Every channel, in one place."
            testId="social-linktree"
          />
          <SocialCard
            href={SOCIAL_LINKS.shoes}
            icon={ExternalLink}
            platform="Alive Shoes"
            handle="WFI Capsule"
            description="The Wealth First Inc. heritage footwear collection."
            testId="social-shoes"
          />
        </div>
      </section>
    </div>
  );
}

function SocialCard({ href, icon: Icon, platform, handle, description, testId }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid={testId}
      className="block p-8 transition-all duration-300 hover:-translate-y-1"
      style={{ border: "1px solid var(--hairline)", background: "var(--surface)" }}
    >
      <Icon size={24} style={{ color: "var(--brass)" }} className="mb-5" />
      <p className="eyebrow mb-2">{platform}</p>
      <p className="font-display text-2xl mb-3">{handle}</p>
      <p className="text-sm leading-relaxed" style={{ color: "var(--ink-muted)" }}>{description}</p>
    </a>
  );
}
